import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=5ecf1fb4&"
import script from "./SidebarView.vue?vue&type=script&lang=js&"
export * from "./SidebarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecf1fb4')) {
      api.createRecord('5ecf1fb4', component.options)
    } else {
      api.reload('5ecf1fb4', component.options)
    }
    module.hot.accept("./SidebarView.vue?vue&type=template&id=5ecf1fb4&", function () {
      api.rerender('5ecf1fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/monitoring/SidebarView.vue"
export default component.exports